// The service fee a store charges on an order.
//
// A store either charges a flat amount or a percentage of the order. In
// percentage mode the fee is held between a floor and a ceiling: a £6 order at
// 10% works out at £0.60, so a £1 minimum charges £1 instead. A maximum of 0
// means no ceiling. `tax` carries the value for both modes -- a percentage or
// an amount, depending on the type.
export function calculateServiceFee(restaurant, amount) {
  const value = Number(restaurant?.tax) || 0
  if (value <= 0) return 0

  if (restaurant?.serviceFeeType === 'FIXED') return value

  const min = Number(restaurant?.serviceFeeMin) || 0
  const max = Number(restaurant?.serviceFeeMax) || 0
  let fee = ((Number(amount) || 0) / 100) * value
  if (fee < min) fee = min
  if (max > 0 && fee > max) fee = max
  return fee
}

export default calculateServiceFee
